import { render, staticRenderFns } from "./HighSeverityNotificationDialog.vue?vue&type=template&id=f16647e6&scoped=true"
import script from "./HighSeverityNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./HighSeverityNotificationDialog.vue?vue&type=script&lang=ts"
import style0 from "./HighSeverityNotificationDialog.vue?vue&type=style&index=0&id=f16647e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16647e6",
  null
  
)

export default component.exports